<template>
  <v-card>
    <v-card-title class="mb-0 pb-1">
      Monthly Service Fee Payment Information
      <v-spacer></v-spacer>
    </v-card-title>
    <v-card-text>
      <v-simple-table
        min-height="160px"
        class="mt-4"
      >
        <template v-slot:default>
          <thead>
            <tr>
              <th
                id="amount"
                class="text-left"
              >
                Amount Paid
              </th>
              <th
                id="balance"
                class="text-left"
              >
                Balance
              </th>
              <th
                id="amount"
                class="text-left"
              >
                Credit Applied
              </th>
              <th
                id="amount"
                class="text-left"
              >
                Amount Credit
              </th>
              <th
                id="balance"
                class="text-left"
              >
                Date Paid
              </th>
            </tr>
          </thead>
          <thead v-show="isLoading">
            <tr>
              <td colspan="3">
                <v-progress-linear
                  indeterminate
                  class="mt-2"
                  rounded
                ></v-progress-linear>
                <p class="text-center mt-1">
                  Loading...Please wait
                </p>
              </td>
            </tr>
          </thead>
          <tbody v-if="monthlyServiceChargePayments.length > 0">
            <tr
              v-for="monthlyServiceChargePayment in monthlyServiceChargePayments"
              :key="monthlyServiceChargePayment.id"
            >
              <td>{{ monthlyServiceChargePayment.amount_paid }}</td>
              <td>{{ monthlyServiceChargePayment.balance }}</td>
              <td>{{ monthlyServiceChargePayment.credit }}</td>
              <td>{{ monthlyServiceChargePayment.amount_over_paid }}</td>
              <td>{{ monthlyServiceChargePayment.created_at | formatDate }}</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr v-show="!isLoading">
              <td
                colspan="5"
                style="text-align: center"
              >
                No monthly service fee payments found
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>

export default {
  props: {
    monthlyServiceChargePayments: {
      type: Array,
      default: null,
    },
    isLoading: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style>

</style>
